import { Component, inject, OnInit, signal } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { noWhitespaceValidator } from '../../../utils/no-whitespace.validator';
import { SystemAdminService } from '../../../services/system-admin.service';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { ToastService } from '../../../services/toast.service';
import { ToastType } from '../../../enums/config.enum';

@Component({
    selector: 'app-system-config',
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, MatExpansionModule],
    templateUrl: './system-config.component.html',
    styleUrl: './system-config.component.scss'
})
export class SystemConfigComponent implements OnInit {

    systemAdminService = inject(SystemAdminService);
    toastService = inject(ToastService)
    isSystemConfigUpdate = signal<boolean>(false);
    configId = signal<number>(0);
    isReadonly = signal<boolean>(true);
    fb: FormBuilder = inject(FormBuilder);
    systemConfigForm = this.fb.group({
        name: [null, [Validators.required, noWhitespaceValidator]],
        environment: [null, [Validators.required, noWhitespaceValidator]],
        // logo: [null, [Validators.required, noWhitespaceValidator]],
        complianceRequirement: [null, [Validators.required, noWhitespaceValidator]],
        prPrimaryURL: [null, [Validators.required, noWhitespaceValidator]],
        prSecondaryURL: [null, [Validators.required, noWhitespaceValidator]],
        acordPrimaryURL: [null, [Validators.required, noWhitespaceValidator]],
        acordSecondaryURL: [null, [Validators.required, noWhitespaceValidator]],
        customURL: [null, [Validators.required, noWhitespaceValidator]],
        resetPasswordCount: [null, [Validators.required, noWhitespaceValidator, Validators.pattern('^[0-9]+$')]],
        resetLinkCount: [null, [Validators.required, noWhitespaceValidator, Validators.pattern('^[0-9]+$')]],

    });

    ngOnInit(): void {
        this.getSystemConfigDetails();
    }
    // onSystemCongigSave()
    // {
    //   if (this.systemConfigForm.invalid)
    //     {
    //       this.systemConfigForm.markAllAsTouched();
    //       return;
    //     }

    // }
    toggleReadonly() {
        this.isReadonly.set(!this.isReadonly());
    }


    getSystemConfigDetails() {
        this.systemAdminService.getSystemConfig().subscribe({
            next: (response: any) => {
                if (response && response.length > 0) {
                    response.forEach((systemConfig: any) => {
                        // Process the single object in the response
                        this.systemConfigForm.patchValue({
                            name: systemConfig.name,
                            // logo: systemConfig.logo,
                            environment: systemConfig.environment,
                            complianceRequirement: systemConfig.complianceRequirement,
                            prPrimaryURL: systemConfig.prPrimaryURL,
                            prSecondaryURL: systemConfig.prSecondaryURL,
                            acordPrimaryURL: systemConfig.acordPrimaryURL,
                            acordSecondaryURL: systemConfig.acordSecondaryURL,
                            customURL: systemConfig.customURL,
                            resetPasswordCount: systemConfig.resetPasswordCount,
                            resetLinkCount: systemConfig.resetLinkCount,
                        });
                        this.configId.set(systemConfig.configId);
                        this.isSystemConfigUpdate.set(true);
                    });
                } else {
                    console.error('Response is invalid or empty:', response);
                }
            },
            error: (error: any) => {
                console.error('Error fetching file config details:', error);
            }
        });
    }

    saveSystemConfig(payload: any) {
        this.systemAdminService.saveSystemConfig(payload).subscribe({
            next: (response: any) => {
                if (response) {
                    this.toastService.addNotification({ message: "System config created", type: ToastType.Success });
                    // if response is success show the prompt
                }
            },
            error: (error: any) => {
                console.log("error", error);
            }
        })
    }

    updateSystemConfig(configId: number, payload: any) {
        this.systemAdminService.updateSystemConfig(configId, payload).subscribe({
            next: (response: any) => {
                if (response) {
                    this.isReadonly.set(true);
                    this.toastService.addNotification({ message: "System Config successfully updated", type: ToastType.Success });
                    // if response is success show the prompt
                }
            },
            error: (error: any) => {
                console.log("error", error);
            }
        })
    }

    onSystemConfigSubmit() {
        if (this.systemConfigForm.invalid) {
            this.systemConfigForm.markAllAsTouched();
            return;
        }

        const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
        const userId = userDetails.userId;

        const rawPayload = this.systemConfigForm.getRawValue() as any;

        const payload = {
            ...rawPayload,
            createdUserId: userId,
            updatedUserId: userId,
            createdDate: new Date().toISOString(),
            updatedDate: new Date().toISOString(),
        };

        this.isSystemConfigUpdate() ? this.updateSystemConfig(this.configId(), payload) : this.saveSystemConfig(payload);
    }

    cancelClick() {
        this.getSystemConfigDetails();
        this.isReadonly.set(true);
    }
}
